import { type MutationError, trpc } from '@/shared/api';

interface UseDeleteCategoryOptions {
  readonly onSuccess?: () => void;
}

/** 카테고리 삭제 — 공개 상품이 유일하게 속한 카테고리는 서버가 거부한다. */
export const useDeleteCategory = ({ onSuccess }: UseDeleteCategoryOptions = {}) => {
  const mutation = trpc.productManagement.categories.delete.useMutation({ onSuccess });

  const error: MutationError | null = mutation.error;

  return {
    deleteCategory: mutation.mutate,
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 같은 오류 줄을 쓰는 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
